const Loading = {
    state: {
        flag: false,
        full: true
    },
    mutations: {
        setLoading(state, payload) {
            state.flag = payload.flag
            state.full = payload.full
        }
    }
}

export default Loading
